import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
} from 'reactstrap';
import classnames from 'classnames';
import { Link, withRouter, Route, Switch } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import BusinessCustomSurveys from 'components/customSurvey/BusinessCustomSurveys';
import BusinessQuestions from 'components/businesses/tabs/questions/BusinessQuestions';
import { ROUTES, insertIdtoUrl } from 'constants/Routes.js';
import { BUSINESS_ADMIN_NAV } from 'constants/NavRoutes.js';
import BusinessUsers from 'components/businesses/tabs/business-users/BusinessUsers';
import Redemption from 'containers/Redemption';

import RequestAddOns from '../tabs/info-edit/RequestAddOns';
import BusinessDashboard from '../../tabNavBar/dashboard/DashboardTab';
import TermsOfUse from '../../../containers/TermsOfUse';
import PrivacyPolicy from '../../../containers/PrivacyPolicy';
import CustomSurveyForm from '../../customSurvey/CustomSurveyForm';
import BusinessDetail from '../../../containers/BusinessDetail';

class BusinessEditTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.props.currentUrl,
      questionToggle: '',
      editId: '',
      reportToggle: '',
      userToggle: '',
      activeSubTab: 'info',
    };

    this.toggle = this.toggle.bind(this);
    this.fetchBusinessId = this.fetchBusinessId.bind(this);
    this.checkTabToggle = this.checkTabToggle.bind(this);
  }

  componentWillMount() {
    this.checkTabToggle(this.props);
    this.fetchBusinessId();
  }

  componentWillReceiveProps(nextProps) {
    this.checkTabToggle(nextProps);
  }

  checkTabToggle(props) {
    const { currentUrl } = props;
    const REPORT_ROUTES = BUSINESS_ADMIN_NAV.DASHBOARD;
    const ADDON_ROUTES = ROUTES.REQUEST_BUSINESS_ADD_ONS;
    const USER_ROUTES = BUSINESS_ADMIN_NAV.USER;
    const REWARD_ROUTES = BUSINESS_ADMIN_NAV.REDEEM;
    const CUSTOM_SURVEY_ROUTES = BUSINESS_ADMIN_NAV.CUSTOM_SURVEY;
    const BUSINESS_ROUTES = ROUTES.BUSINESS_DETAIL;
    const QUESTIONS_ROUTES = ROUTES.CUSTOM_SURVEY_QUESTIONS;

    if (ADDON_ROUTES.includes(currentUrl)) {
      this.setState({ activeTab: 'addons' });
    } else if (REPORT_ROUTES.includes(currentUrl)) {
      this.setState({ activeTab: 'dashboard' });
    } else if (USER_ROUTES.includes(currentUrl)) {
      this.setState({ activeTab: 'users' });
    } else if (REWARD_ROUTES.includes(currentUrl)) {
      this.setState({ activeTab: 'redemption' });
    } else if (CUSTOM_SURVEY_ROUTES.includes(currentUrl)) {
      this.setState({ activeTab: 'custom_surveys' });
    } else if (BUSINESS_ROUTES.includes(currentUrl)) {
      this.setState({ activeTab: 'business' });
    } else if (QUESTIONS_ROUTES.includes(currentUrl)) {
      this.setState({ activeTab: 'questions' });
    }
  }

  fetchBusinessId() {
    const { businessId } = this.props;

    this.setState({
      editId: businessId,
    });
  }

  toggle(tab) {
    const { activeTab } = this.state;

    if (activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    const REPORT_ROUTES = BUSINESS_ADMIN_NAV.DASHBOARD;
    const ADDON_ROUTES = ROUTES.REQUEST_BUSINESS_ADD_ONS;
    const USER_ROUTES = BUSINESS_ADMIN_NAV.USER;
    const REWARD_ROUTES = BUSINESS_ADMIN_NAV.REDEEM;
    const CUSTOM_SURVEY_ROUTES = BUSINESS_ADMIN_NAV.CUSTOM_SURVEY;
    const BUSINESS_ROUTES = ROUTES.BUSINESS_DETAIL;
    const QUESTIONS_ROUTES = ROUTES.CUSTOM_SURVEY_QUESTIONS;

    const { editId, activeTab } = this.state;
    const { currentUrl, businessName } = this.props;

    return (
      <div>
        <div className="below-header pt-3">
          <div className="container">
            <Nav tabs>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={insertIdtoUrl(ROUTES.REPORT_LIST, editId)}
                  className={`${classnames({
                    active: REPORT_ROUTES.includes(currentUrl),
                  })}`}
                  onClick={() => {
                    this.toggle('dashboard');
                  }}
                >
                  Dashboard
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={insertIdtoUrl(ROUTES.CUSTOM_SURVEY_LIST, editId)}
                  className={`${classnames({
                    active: (CUSTOM_SURVEY_ROUTES.includes(currentUrl) || QUESTIONS_ROUTES.includes(currentUrl)),
                  })}`}
                  onClick={() => {
                    this.toggle('custom_surveys');
                  }}
                >
                  Surveys
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={insertIdtoUrl(ROUTES.REQUEST_BUSINESS_ADD_ONS, editId)}
                  className={`${classnames({
                    active: ADDON_ROUTES.includes(currentUrl),
                  })}`}
                  onClick={() => {
                    this.toggle('addons');
                  }}
                >
                  Add-ons
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={insertIdtoUrl(ROUTES.REWARD_ISSUED, editId)}
                  className={`${classnames({
                    active: REWARD_ROUTES.includes(currentUrl),
                  })}`}
                  onClick={() => {
                    this.toggle('redemption');
                  }}
                >
                  Participants
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={insertIdtoUrl(ROUTES.BUSINESS_DETAIL, editId)}
                  className={`${classnames({
                    active: BUSINESS_ROUTES.includes(currentUrl),
                  })}`}
                  onClick={() => {
                    this.toggle('business');
                  }}
                >
                  Business
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={insertIdtoUrl(ROUTES.USERS_LIST, editId)}
                  className={`${classnames({
                    active: USER_ROUTES.includes(currentUrl),
                  })}`}
                  onClick={() => {
                    this.toggle('users');
                  }}
                >
                  Users
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>
        <div className="container">
          <div className="businessname-display">
            <h3>
              <FontAwesomeIcon icon="store" />
              {businessName}
            </h3>
          </div>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="dashboard">
              <Row>
                <Col sm="12">
                  <BusinessDashboard />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="custom_surveys">
              <Row>
                <Col sm="12">
                  <Switch>
                    <Route exact path={ROUTES.CUSTOM_SURVEY_EDIT} component={CustomSurveyForm} />
                    <BusinessCustomSurveys editId={editId} />
                  </Switch>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="questions">
              <Row>
                <Col sm="12">
                  <BusinessQuestions businessId={editId} />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="addons">
              <Row>
                <Col sm="12">
                  <RequestAddOns editId={editId} />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="redemption">
              <Row>
                <Col sm="12">
                  <Redemption
                    businessId={editId}
                    currentUrl={this.props.match.params.path}
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="business">
              <Row>
                <Col sm="12">
                  <BusinessDetail />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="users">
              <Row>
                <Col sm="12">
                  <BusinessUsers businessId={editId} />
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
      </div>
    );
  }
}

BusinessEditTab.propTypes = {
  currentUrl: PropTypes.string,
  businessId: PropTypes.string.isRequired,
  businessName: PropTypes.string,
  customSurveyId: PropTypes.string,
};

export default withRouter(BusinessEditTab);



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/BusinessEditTab.js